export default __webpack_public_path__ + "static/media/button.7608006a.mp3";